(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tomo-daily-deal-clock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tomo-daily-deal-clock')) {
    const pacificFormatter = new Intl.DateTimeFormat('en-US', { timeZone:'America/Los_Angeles', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' });
    const pacificParts = ms => Object.fromEntries(pacificFormatter.formatToParts(new Date(ms)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    function nextPacificMidnight(ms) {
      const p = pacificParts(ms);
      const wallTarget = Date.UTC(p.year, p.month - 1, p.day + 1);
      let target = wallTarget + 8 * 3600000;
      for (let i = 0; i < 3; i++) {
        const local = pacificParts(target);
        const wall = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
        target += wallTarget - wall;
      }
      return target;
    }
    const SLIDE_SELECTOR = '.tomo-cb__slide[href]';
    const LINK_CACHE_KEY = 'tomoDailyClockLink';
    const LINK_CACHE_MS = 30 * 60000;
    const sameOrigin = href => {
      try { const url = new URL(href, location.href); return url.origin === location.origin ? url.href : null; } catch { return null; }
    };
    const readLinkCache = () => {
      try { const c = JSON.parse(localStorage.getItem(LINK_CACHE_KEY)); return c && Date.now() - c.at < LINK_CACHE_MS ? sameOrigin(c.href) : null; } catch { return null; }
    };
    const writeLinkCache = href => {
      try { localStorage.setItem(LINK_CACHE_KEY, JSON.stringify({href, at: Date.now()})); } catch {}
    };
    // Reads the homepage only as far as its first campaign banner slide.
    async function fetchCurrentSaleLink(homeUrl) {
      const response = await fetch(homeUrl, {credentials: 'same-origin'});
      if (!response.ok || !response.body) return null;
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      const pattern = /class="tomo-cb__slide" href="([^"]+)"/;
      let html = '';
      for (;;) {
        const {done, value} = await reader.read();
        if (value) html += decoder.decode(value, {stream: true});
        const match = pattern.exec(html);
        if (match || done || html.includes('</main>')) {
          reader.cancel().catch(() => {});
          if (!match) return null;
          const field = document.createElement('textarea');
          field.innerHTML = match[1];
          return sameOrigin(field.value);
        }
      }
    }
    let currentSaleLink;
    function resolveCurrentSaleLink(homeUrl) {
      if (currentSaleLink) return currentSaleLink;
      const slide = document.querySelector('slideshow-slide[aria-label^="1 of "] ' + SLIDE_SELECTOR) || document.querySelector(SLIDE_SELECTOR);
      const onPage = slide && sameOrigin(slide.getAttribute('href'));
      if (onPage) {
        writeLinkCache(onPage);
        return currentSaleLink = Promise.resolve(onPage);
      }
      const cached = readLinkCache();
      if (cached) return currentSaleLink = Promise.resolve(cached);
      if (navigator.connection?.saveData) return currentSaleLink = Promise.resolve(null);
      return currentSaleLink = new Promise(resolve => {
        const run = () => fetchCurrentSaleLink(homeUrl).then(href => { if (href) writeLinkCache(href); resolve(href); }).catch(() => resolve(null));
        if ('requestIdleCallback' in window) requestIdleCallback(run, {timeout: 4000}); else setTimeout(run, 1500);
      });
    }
    class TomoDailyDealClock extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('.tomo-daily-clock__link[data-auto-link]');
        if (link) resolveCurrentSaleLink(link.dataset.homeUrl || '/').then(href => { if (href && this.isConnected) link.href = href; });
        this.optimizedScroll = this.hasAttribute('data-scroll-optimized');
        this.parts = ['hours','minutes','seconds'].map(name => this.querySelector('[data-clock-' + name + ']'));
        if (this.parts.some(part => !part)) return;
        this.finaleEnd = Date.parse('2026-09-09T00:00:00-07:00');
        this.copyParts=[...this.querySelectorAll('[data-clock-label],[data-clock-subtitle]')].map(node=>({node,daily:node.textContent}));
        this.timerLabel=this.querySelector('[data-clock-timer]');this.dailyTimerLabel=this.timerLabel?.getAttribute('aria-label');
        this.target = Date.now()<this.finaleEnd?this.finaleEnd:nextPacificMidnight(Date.now());
        this.tick = () => {
          if (this.optimizedScroll && document.hidden) return;
          const now = Date.now();
          const finale=now<this.finaleEnd;
          if (!this.optimizedScroll || this.previousFinale !== finale) {
            this.copyParts.forEach(({node,daily})=>node.textContent=finale?node.dataset.finale:daily);
            this.classList.toggle('is-finale',finale);
            if(this.timerLabel)this.timerLabel.setAttribute('aria-label',finale?this.timerLabel.dataset.finale:this.dailyTimerLabel);
            this.previousFinale = finale;
          }
          if (finale) this.target=this.finaleEnd; else if (now >= this.target || this.target - now > 25 * 3600000) this.target = nextPacificMidnight(now);
          const total = Math.max(0, Math.ceil((this.target - now) / 1000));
          const values = [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60];
          this.parts.forEach((part,i) => {
            const value = String(values[i]).padStart(2,'0');
            if (!this.optimizedScroll || part.textContent !== value) part.textContent = value;
          });
          if (!this.optimizedScroll || this.hidden) this.hidden = false;
        };
        this.tick();
        this.setupSticky();
        this.interval = setInterval(this.tick,1000);
        document.addEventListener('visibilitychange',this.tick);
      }
      setupSticky() {
        this.clockSlot = this.parentElement;
        this.header = document.querySelector('.headerGroup') || document.querySelector('header-component');
        if (this.optimizedScroll && this.header && getComputedStyle(this.header).position === 'fixed' && 'IntersectionObserver' in window && 'ResizeObserver' in window) {
          this.setupOptimizedSticky();
          return;
        }
        this.updateSticky = () => {
          cancelAnimationFrame(this.stickyFrame);
          this.stickyFrame = requestAnimationFrame(() => {
            if (!this.isConnected) return;
            const rect = this.header?.getBoundingClientRect();
            const top = rect && rect.width && rect.bottom > 0 ? Math.max(0, rect.bottom) : 0;
            this.style.setProperty('--tomo-clock-top', top + 'px');
            const stuck = this.clockSlot.getBoundingClientRect().top < top;
            this.clockSlot.style.height = this.offsetHeight + 'px';
            this.classList.toggle('is-stuck', stuck);
          });
        };
        this.observePosition = () => {
          this.positionObserver?.disconnect();
          const top = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
          this.positionObserver = new IntersectionObserver(this.updateSticky, {rootMargin: '-' + top + 'px 0px 0px 0px', threshold: [0,1]});
          this.positionObserver.observe(this.clockSlot);
          this.updateSticky();
        };
        this.stickyResize = new ResizeObserver(this.observePosition);
        this.stickyResize.observe(this);
        if (this.header) this.stickyResize.observe(this.header);
        window.addEventListener('scroll', this.updateSticky, {passive:true});
        window.addEventListener('resize', this.observePosition);
        this.observePosition();
      }
      setupOptimizedSticky() {
        this.setStickyState = stuck => {
          if (this.isStuck === stuck) return;
          this.isStuck = stuck;
          this.classList.toggle('is-stuck', stuck);
        };
        this.observePosition = () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.stickyFrame = 0;
            if (!this.isConnected) return;
            const rect = this.header.getBoundingClientRect();
            const top = rect.width && rect.bottom > 0 ? Math.max(0, rect.bottom) : 0;
            const height = this.offsetHeight;
            const slotTop = this.clockSlot.getBoundingClientRect().top;
            const topChanged = this.stickyTop !== top;
            if (topChanged) {
              this.stickyTop = top;
              this.style.setProperty('--tomo-clock-top', top + 'px');
            }
            if (this.slotHeight !== height) {
              this.slotHeight = height;
              this.clockSlot.style.height = height + 'px';
            }
            this.setStickyState(slotTop < top);
            if (topChanged || !this.positionObserver) {
              this.positionObserver?.disconnect();
              this.positionObserver = new IntersectionObserver(entries => {
                if (!this.isConnected) return;
                const entry = entries[entries.length - 1];
                if (entry) this.setStickyState(entry.boundingClientRect.top < this.stickyTop);
              }, {rootMargin: '-' + top + 'px 0px 0px 0px', threshold: [0,1]});
              this.positionObserver.observe(this.clockSlot);
            }
          });
        };
        this.stickyResize = new ResizeObserver(this.observePosition);
        this.stickyResize.observe(this);
        this.stickyResize.observe(this.header);
        window.addEventListener('resize', this.observePosition, {passive:true});
        this.observePosition();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.stickyFrame);
        this.positionObserver?.disconnect();this.stickyResize?.disconnect();
        window.removeEventListener('scroll',this.updateSticky);
        window.removeEventListener('resize',this.observePosition);
        this.classList.remove('is-stuck');if(this.clockSlot)this.clockSlot.style.height='';
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange',this.tick);
      }
    }
    customElements.define('tomo-daily-deal-clock',TomoDailyDealClock);
  }
  } catch(e) { console.error(e); }
})();

})();
